import { createContext, SetStateAction } from "react";
import { SubscriptionClient } from "subscriptions-transport-ws";
import { Project, Company } from "types";

export type Settings = {
    showGlobal: boolean;
    showRunning: boolean;
    debugTraces: boolean;
    verticalOrientation: boolean;
};
export const defaultSettings: Settings = {
    showGlobal: false,
    showRunning: false,
    debugTraces: false,
    verticalOrientation: false
};

export const SettingsContext = createContext<[Settings, (value: SetStateAction<Settings>, store?: boolean) => void]>([
    defaultSettings,
    () => console.warn("SettingsContext not provided")
]);

export const SelectedProjectContext = createContext<
    [Project | undefined, (action: React.SetStateAction<Project | undefined>) => void]
>([undefined, () => console.warn("SelectedProjectContext not provided")]);

export const SelectedCompanyContext = createContext<
    [Company | undefined, (action: React.SetStateAction<Company | undefined>) => void]
>([undefined, () => console.warn("SelectedCompanyContext not provided")]);

export const SnContext = createContext("");

export const SubscriptionClientContext = createContext<SubscriptionClient | undefined>(undefined);

export const TimeZoneContext = createContext<[string, (action: React.SetStateAction<string>) => void]>([
    "",
    () => console.warn("TimeZoneContext not provided")
]);

export const DateRangeFilterContext = createContext<
    [[Date | null, Date | null], (action: React.SetStateAction<[Date | null, Date | null]>) => void]
>([[null, null], () => console.warn("TimeZoneContext not provided")]);
